import DeleteWorkspace from './DeleteWorkspace';
export default DeleteWorkspace;
